exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wraper-container-PaymentListFarms .context-item-fixed {\n  margin-left: 110px !important;\n}\n.wraper-container-PaymentListFarms .context-item-fixed .fpayment-page-listing-farms {\n  width: 100%;\n  height: 100%;\n}", ""]);

// exports
